import api from '../api';

const BASE_URL = '/api/v2/ai-agent-personalities';

const AiAgentPersonalitiesApi = {
	getAllAiAgentPersonalities: ({ page, perPage, title }) =>
		api.get(
			`${BASE_URL}?${page ? `pageNumber=${page}` : ''}${perPage ? `&pageSize=${perPage}` : ''}${
				title ? `&title=${title}` : ''
			}`
		),
	getAiAgentPersonality: (aiAgentPersonalityId) => api.get(`${BASE_URL}/${aiAgentPersonalityId}`),
	createAiAgentPersonality: (payload) => api.post(BASE_URL, payload),
	updateAiAgentPersonality: (aiAgentPersonalityId, payload) =>
		api.patch(`${BASE_URL}/${aiAgentPersonalityId}`, payload),
	deleteAiAgentPersonality: (aiAgentPersonalityId) =>
		api.delete(`${BASE_URL}/${aiAgentPersonalityId}`),
};

export default AiAgentPersonalitiesApi;
